import ChannelSliderLazyContainer from './ChannelSliderLazyContainer';
export default ChannelSliderLazyContainer;
